import React, { PropsWithChildren } from 'react';
import cn from 'classnames/bind';

import styles from './styles.module.css';

const cx = cn.bind(styles);

interface Props {
    className?: string;
}

export const InfoBlockSubtitle = ({ className, children }: PropsWithChildren<Props>) => (
    <div className={cx('root', className)}>{children}</div>
);
